/**
 * Login-Page (Phase 3.5 §3 + §5 Dark-Theme + Logo).
 *
 * Zwei Wege: E-Mail/Passwort (mit „eingeloggt bleiben") ODER Google-OAuth.
 * Plus „Passwort vergessen". E-Mail-Login speichert den Token direkt und lädt neu;
 * Google leitet weiter und kommt über /login/callback zurück.
 */

import { redirectToLogin } from "../auth/login";
import { setToken } from "../auth/token";
import { apiLogin } from "../api/client";
import { sanitizeRedirectTarget } from "../auth/callback";

export function renderLoginPage(host: HTMLElement, opts: { redirectTo?: string } = {}): void {
  host.innerHTML = `
    <div class="login-page">
      <div class="login-card">
        <div class="login-brand">
          <img src="/logo.png" alt="CoTrainer" />
          <h1>CoTrainer Controlling</h1>
        </div>

        <form id="login-form" class="auth-form" novalidate>
          <label class="auth-label">E-Mail
            <input type="email" id="login-email" class="auth-input" autocomplete="username" required />
          </label>
          <label class="auth-label">Passwort
            <input type="password" id="login-pw" class="auth-input" autocomplete="current-password" required />
          </label>
          <label class="auth-checkline">
            <input type="checkbox" id="login-remember" /> <span>Eingeloggt bleiben</span>
          </label>
          <button type="submit" class="login-btn auth-submit"><span>Anmelden</span></button>
          <p id="login-msg" class="auth-msg"></p>
        </form>

        <p class="login-footnote"><a href="/passwort-vergessen">Passwort vergessen?</a></p>

        <div class="auth-divider"><span>oder</span></div>

        <button id="login-google-btn" class="login-btn login-btn-google" type="button">
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
            <path d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
            <path d="M3.964 10.706A5.41 5.41 0 0 1 3.682 9c0-.591.102-1.166.282-1.706V4.962H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" fill="#FBBC05"/>
            <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z" fill="#EA4335"/>
          </svg>
          <span>Login mit Google</span>
        </button>
        <small class="login-footnote">
          Bei Google wirst du weitergeleitet und kommst danach automatisch hierher zurück.
        </small>
      </div>
    </div>
  `;

  const setMsg = (text: string, kind: "error" | "info" = "error") => {
    const el = host.querySelector<HTMLElement>("#login-msg");
    if (!el) return;
    el.textContent = text;
    el.className = `auth-msg auth-msg-${kind}`;
  };

  host.querySelector<HTMLFormElement>("#login-form")?.addEventListener("submit", async (e) => {
    e.preventDefault();
    const email = host.querySelector<HTMLInputElement>("#login-email")!.value.trim();
    const pw = host.querySelector<HTMLInputElement>("#login-pw")!.value;
    const remember = host.querySelector<HTMLInputElement>("#login-remember")!.checked;
    if (!email || !pw) return setMsg("Bitte E-Mail und Passwort eingeben.");
    const btn = host.querySelector<HTMLButtonElement>(".auth-submit")!;
    btn.disabled = true;
    setMsg("Anmelden…", "info");
    try {
      const res = await apiLogin(email, pw, remember);
      setToken(res.token, res.exp);
      window.location.href = sanitizeRedirectTarget(opts.redirectTo ?? "/");
    } catch (err) {
      btn.disabled = false;
      setMsg((err as Error).message || "Anmeldung fehlgeschlagen.");
    }
  });

  host.querySelector("#login-google-btn")?.addEventListener("click", () => {
    redirectToLogin(opts.redirectTo);
  });
}
